export var fontFamily = "'Inter', sans-serif"; //TODO resolve why custom variants don't inherit fontFamily
export var typography = {
    allVariants: {
        fontFamily: fontFamily,
    },
    h1: {
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: 0,
    },
    'h1-bold': {
        fontSize: 28,
        fontWeight: 700,
        lineHeight: '32px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    h2: {
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: 0,
    },
    'h2-bold': {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '24px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    h3: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: 0,
    },
    h4: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: 0,
    },
    h5: {
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: 0,
    },
    body: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '24px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    'body-medium': {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '24px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    'body-bold': {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '24px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    caption: {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '16px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    'caption-medium': {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    'caption-bold': {
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '16px',
        fontFamily: fontFamily,
        letterSpacing: 0,
    },
    button: {
        textTransform: 'none',
        fontFamily: fontFamily,
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: 0,
    },
};
export var MuiTypography = {
    defaultProps: {
        variantMapping: {
            h1: 'h1',
            'h1-bold': 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
            body: 'span',
            'body-medium': 'span',
            'body-bold': 'span',
            caption: 'span',
            'caption-bold': 'span',
        },
    },
};
